import { isPast, endOfDay } from 'date-fns';

const checkDateInThePast = (date: string) => {
  return isPast(endOfDay(new Date(date)));
};

export default checkDateInThePast;
